<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode }" class="c-app">
    <CContainer class="d-flex align-items-center min-vh-100">
      <CRow class="w-100 justify-content-center">
        <CCol md="8" lg="6">
          <CCard>
            <CCardBody class="text-center py-5">
              <div class="mb-4">
                <CIcon name="cilLockLocked" size="5xl" class="text-danger mb-3"/>
                <h1 class="display-3 text-danger">403</h1>
                <h4 class="mb-3">Access Forbidden</h4>
                <p class="text-muted mb-4">
                  You don't have permission to access this page.
                </p>
                <p class="text-muted small">
                  If you believe you should have access, please contact your system administrator.
                </p>
              </div>

              <div class="d-flex justify-content-center gap-2">
                <CButton
                  color="primary"
                  @click="goToDashboard"
                  class="px-4"
                >
                  <CIcon name="cilHome" class="mr-1"/>
                  Go to Dashboard
                </CButton>
                <CButton
                  color="secondary"
                  @click="goBack"
                  class="px-4"
                >
                  <CIcon name="cilArrowLeft" class="mr-1"/>
                  Go Back
                </CButton>
              </div>

              <div class="mt-4 pt-4 border-top" v-if="currentUser">
                <p class="text-muted small mb-1">
                  <strong>Current User:</strong> {{ currentUser.displayName || currentUser.userName }}
                </p>
                <p class="text-muted small mb-0">
                  <strong>Role:</strong> {{ currentUser.role }}
                </p>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Page403',
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
